import { useImpersonation } from "../../contexts/useSuperuser";

export default function ImpersonationBanner() {
  const { impersonatedUser, stopImpersonation } = useImpersonation();

  if (!impersonatedUser) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-[#ff6b35] text-white px-4 py-2 flex items-center justify-between gap-4 font-semibold text-sm shadow-md">
      <span className="flex items-center gap-4 flex-wrap">
        <span>
          Viewing as <strong>{impersonatedUser.email}</strong> (
          {impersonatedUser.name})
        </span>
        <span className="text-[11px] font-extrabold tracking-wider bg-black/25 px-2 py-0.5 rounded-sm">
          ⚠ WARNING: ALL ACTIONS AND CHANGES HERE DIRECTLY AFFECT THIS
          USER&apos;S ACCOUNT. USE CAUTION.
        </span>
      </span>
      <button
        onClick={stopImpersonation}
        className="bg-white/25 border border-white/60 text-white px-3 py-1 rounded cursor-pointer font-semibold text-[13px] whitespace-nowrap shrink-0"
      >
        Stop Impersonating
      </button>
    </div>
  );
}
